import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Onlinetaxibookingmumbai() {



    const cardData = {

keyword: "Online Taxi Booking Mumbai",

headingDescription:
    "Mumbai Airport Cab offers fast, easy, and reliable Online Taxi Booking in Mumbai for local travel, airport transfers, outstation trips, corporate travel, and daily commuting needs. With a simple booking process via call or online request, customers can get instant confirmation and doorstep pickup anywhere in Mumbai. We provide a wide range of well-maintained vehicles including Sedan, SUV, Innova Crysta, Ertiga, Tempo Traveller, Luxury Urbania, and Mini Bus with professional and verified chauffeurs. With 24x7 availability, transparent pricing, safe rides, and on-time service, we ensure a smooth and hassle-free travel experience across Mumbai and nearby locations.",

  topPlaces: [

            {
                title: "Mahabaleshwar & Panchgani",
                description:
                    "Mahabaleshwar and Panchgani are renowned hill stations known for strawberry farms, beautiful valleys, ancient temples, and panoramic viewpoints. Visitors can explore Venna Lake, Arthur's Seat, Mapro Garden, Table Land, and local markets while enjoying the cool climate. Outstation cab travel from Mumbai provides a relaxed and comfortable way to experience these scenic destinations with family and friends."
            },
            {
                title: "Shirdi & Shani Shingnapur",
                description:
                    "Shirdi is one of India's most important pilgrimage destinations, attracting millions of Sai Baba devotees every year. Many travelers combine their visit with Shani Shingnapur, the famous temple dedicated to Lord Shani. Mumbai outstation cabs offer flexible itineraries for darshan, family pilgrimages, and spiritual journeys with comfortable highway travel and convenient stops along the route."
            },
                        {
                title: "Lonavala & Khandala",
                description:
                    "Lonavala and Khandala are among the most popular weekend destinations from Mumbai, famous for scenic valleys, waterfalls, historic caves, and pleasant weather. Travelers enjoy attractions such as Tiger Point, Bhushi Dam, Rajmachi Point, and Karla Caves. The smooth expressway route and beautiful Sahyadri landscapes make this destination perfect for family holidays, corporate outings, and short road trips throughout the year."
            },
            {
                title: "Nashik & Trimbakeshwar",
                description:
                    "Nashik is a spiritual and cultural city famous for Trimbakeshwar Jyotirlinga, Panchavati, ancient temples, vineyards, and the sacred Godavari River. It attracts pilgrims, wine enthusiasts, and history lovers alike. Outstation cab services from Mumbai provide an excellent option for visiting both religious and tourist attractions comfortably during a single trip."
            },
            {
                title: "Alibaug & Murud",
                description:
                    "Alibaug and Murud are beautiful coastal destinations known for sandy beaches, sea forts, water sports, and peaceful surroundings. Tourists visit Kolaba Fort, Murud-Janjira Fort, Kashid Beach, and local fishing villages for a relaxing holiday. Mumbai outstation cabs make beach vacations convenient with direct doorstep pickup and flexible sightseeing schedules."
            },
            {
                title: "Goa",
                description:
                    "Goa remains one of the most sought-after long-distance road trip destinations from Mumbai, offering beautiful beaches, Portuguese architecture, nightlife, water sports, churches, and seafood cuisine. Popular attractions include Baga Beach, Calangute, Fort Aguada, Basilica of Bom Jesus, and Dudhsagar Falls. Comfortable outstation cabs make the long journey enjoyable for families and groups."
            },
            {
                title: "Aurangabad, Ajanta & Ellora",
                description:
                    "Aurangabad is famous for its rich historical heritage and proximity to the UNESCO World Heritage Sites of Ajanta and Ellora Caves. Travelers can also visit Bibi Ka Maqbara, Daulatabad Fort, and Grishneshwar Jyotirlinga. Mumbai outstation cab services allow visitors to explore history, spirituality, and architecture through a comfortable multi-day road journey."
            },
            {
                title: "Matheran",
                description:
                    "Matheran is a charming eco-sensitive hill station where motor vehicles are restricted, creating a peaceful atmosphere for visitors. Popular attractions include Panorama Point, Charlotte Lake, Echo Point, and horse riding trails through lush forests. Outstation cabs from Mumbai provide easy access to the base point, making family trips and weekend escapes highly convenient."
            },
            {
                title: "Ganpatipule & Ratnagiri",
                description:
                    "Ganpatipule and Ratnagiri are famous Konkan destinations known for pristine beaches, the revered Ganpati temple, sea forts, and traditional coastal culture. Visitors enjoy beautiful coastal drives, fresh seafood, mango orchards, and peaceful seaside landscapes. Mumbai outstation cab services offer a comfortable and scenic journey through the picturesque Konkan region."
            },
            {
                title: "Udaipur",
                description:
                    "Udaipur, the City of Lakes, is a popular long-distance destination from Mumbai known for royal palaces, historic forts, cultural heritage, and beautiful lakes. Attractions such as City Palace, Lake Pichola, Fateh Sagar Lake, Jag Mandir, and Saheliyon Ki Bari make it a memorable travel experience. Outstation cab travel provides flexibility for sightseeing while enjoying Rajasthan's rich history and hospitality."
            }
        ],



services: [
{
name: "Online Taxi Booking Mumbai",
description: "Mumbai Airport Cab offers Online Taxi Booking Mumbai for fast, safe, and convenient travel across the city and nearby regions. Whether you need airport transfers, local city rides, business travel, family trips, or outstation journeys, our platform provides instant booking with a wide range of AC Sedan, SUV, Innova Crysta, Ertiga, Kia Carens, Tempo Traveller, Force Urbania, and luxury vehicles. With 24x7 availability, real-time driver allocation, transparent pricing, and doorstep pickup, we ensure a smooth and hassle-free travel experience. Our online booking system is designed for quick confirmation, secure payments, and reliable service anytime you need a ride."
},
{
name: "Mumbai Online Cab Booking",
description: "Book Mumbai Online Cab Booking with Mumbai Airport Cab for instant ride confirmation, professional chauffeurs, and comfortable AC vehicles. We provide flexible travel options for local, airport, and outstation trips at affordable prices."
},
{
name: "Book Taxi Online Mumbai",
description: "Choose Book Taxi Online Mumbai for quick and easy cab reservations. Enjoy seamless booking, multiple vehicle options, verified drivers, and 24x7 customer support for all travel needs."
},
{
name: "Mumbai Taxi Booking App",
description: "Mumbai Airport Cab provides a user-friendly Mumbai Taxi Booking App experience for instant ride booking, live tracking, secure payments, and fast driver assignment for smooth transportation."
},
{
name: "Instant Taxi Booking Mumbai",
description: "Get Instant Taxi Booking Mumbai with immediate confirmation, quick driver dispatch, and reliable pickup service for urgent travel and planned trips alike."
},
{
name: "Fast Taxi Booking Mumbai",
description: "Fast Taxi Booking Mumbai ensures quick ride confirmation, minimal waiting time, and efficient driver allocation for smooth and time-saving travel."
},
{
name: "Easy Online Cab Mumbai",
description: "Easy Online Cab Mumbai allows hassle-free booking with simple steps, transparent pricing, and multiple vehicle choices for all travel requirements."
},
{
name: "Mumbai Ride Booking Online",
description: "Mumbai Ride Booking Online offers flexible transportation for daily commutes, airport transfers, and long-distance trips with safe and comfortable vehicles."
},
{
name: "24x7 Online Taxi Mumbai",
description: "Mumbai Airport Cab provides 24x7 Online Taxi Mumbai service ensuring round-the-clock availability for early morning, late-night, and emergency travel needs."
},
{
name: "App Based Taxi Booking Mumbai",
description: "App Based Taxi Booking Mumbai offers seamless digital booking with live tracking, instant confirmation, and secure payment options for a smooth travel experience."
},
{
name: "Mumbai Cab Booking Online",
description: "Mumbai Cab Booking Online provides reliable and fast booking options with professional drivers, clean vehicles, and transparent pricing for all journeys."
},
{
name: "Quick Taxi Booking Mumbai",
description: "Quick Taxi Booking Mumbai ensures rapid confirmation and fast pickup service, reducing waiting time and improving travel convenience."
},
{
name: "Digital Taxi Booking Mumbai",
description: "Digital Taxi Booking Mumbai allows fully online reservations with secure payment systems, instant confirmation, and real-time ride management."
},
{
name: "Mobile Taxi Booking Mumbai",
description: "Mobile Taxi Booking Mumbai enables users to book rides easily from smartphones with fast processing, driver tracking, and 24x7 support."
},
{
name: "Mumbai Online Ride Service",
description: "Mumbai Online Ride Service provides convenient transportation for city travel, airport transfers, and outstation trips with reliable drivers and comfortable vehicles."
},
{
name: "Safe Online Taxi Booking Mumbai",
description: "Safe Online Taxi Booking Mumbai ensures verified drivers, GPS-enabled vehicles, secure payments, and high safety standards for every ride."
},
{
name: "Affordable Online Taxi Mumbai",
description: "Affordable Online Taxi Mumbai offers budget-friendly fares with transparent pricing and economical travel options without compromising comfort."
},
{
name: "Mumbai Travel Booking App",
description: "Mumbai Travel Booking App experience provides seamless cab reservations, instant confirmation, and flexible travel options for all passengers."
},
{
name: "Mumbai Instant Ride Booking",
description: "Mumbai Instant Ride Booking offers immediate cab availability with quick driver allocation and fast pickup for urgent travel needs."
},
{
name: "Mumbai Cab App Booking",
description: "Mumbai Cab App Booking provides an easy-to-use digital platform for booking taxis with live tracking, secure payments, and reliable service."
}
],

tableData: [
["Online Taxi Booking Mumbai","Mumbai Online Cab Booking"],
["Book Taxi Online Mumbai","Mumbai Taxi Booking App"],
["Instant Taxi Booking Mumbai","Fast Taxi Booking Mumbai"],
["Easy Online Cab Mumbai","Mumbai Ride Booking Online"],
["24x7 Online Taxi Mumbai","App Based Taxi Booking Mumbai"],
["Mumbai Cab Booking Online","Quick Taxi Booking Mumbai"],
["Digital Taxi Booking Mumbai","Mobile Taxi Booking Mumbai"],
["Safe Online Taxi Booking Mumbai","Affordable Online Taxi Mumbai"],
["Mumbai Travel Booking App","Mumbai Instant Ride Booking"],
["Mumbai Cab App Booking","Mumbai Online Ride Service"]
],



whychoose: [
{
WhyChooseheading: "Easy Online Taxi Booking in Mumbai",
WhyChoosedescription: "Mumbai Airport Cabs provides convenient online taxi booking services in Mumbai for airport transfers, local rides, corporate travel, sightseeing tours, and outstation journeys."
},
{
WhyChooseheading: "Quick and Hassle-Free Reservation Process",
WhyChoosedescription: "Customers can easily book taxis through phone calls, WhatsApp, or online inquiries without complicated procedures or lengthy waiting times."
},
{
WhyChooseheading: "Available 24x7 for Every Travel Need",
WhyChoosedescription: "Our online taxi booking service is available round the clock for airport pickups, emergency travel, business meetings, and family transportation."
},
{
WhyChooseheading: "Wide Range of Vehicle Options",
WhyChoosedescription: "Choose from Sedan cars, Ertiga, Innova Crysta, SUVs, Tempo Travellers, and premium vehicles according to passenger count and luggage requirements."
},
{
WhyChooseheading: "Local and Outstation Taxi Services",
WhyChoosedescription: "Whether you need a taxi within Mumbai or for destinations like Pune, Nashik, Shirdi, Goa, Ahmedabad, or Indore, we offer reliable travel solutions."
},
{
WhyChooseheading: "Airport Transfer Specialists",
WhyChoosedescription: "We provide timely airport pickup and drop services from Mumbai Airport with professional drivers and comfortable vehicles."
},
{
WhyChooseheading: "Professional Drivers and Safe Travel",
WhyChoosedescription: "Our trained chauffeurs focus on passenger safety, punctuality, and customer satisfaction throughout every journey."
},
{
WhyChooseheading: "Suitable for Individuals and Groups",
WhyChoosedescription: "From solo travelers to large family groups and corporate teams, we provide suitable transportation options for all travel requirements."
}
]
};

const faqData = [
{
question: "How can I book a taxi online in Mumbai?",
answer: "You can book a taxi through phone calls, WhatsApp messages, or online inquiries with Mumbai Airport Cabs."
},
{
question: "Is online taxi booking available 24x7?",
answer: "Yes, our online taxi booking service is available 24 hours a day for airport transfers, local travel, and outstation trips."
},
{
question: "Which vehicles are available for online booking?",
answer: "Customers can book Sedan cars, Ertiga, Innova Crysta, SUVs, Tempo Travellers, and premium vehicles."
},
{
question: "Can I book a taxi for Mumbai Airport transfers?",
answer: "Yes, airport pickup and drop services are available for domestic and international travelers."
},
{
question: "Do you provide outstation taxi bookings from Mumbai?",
answer: "Yes, customers can book taxis for Pune, Nashik, Shirdi, Goa, Mahabaleshwar, Ahmedabad, Bangalore, Jaipur, and many other destinations."
},
{
question: "Can corporate travelers use online booking services?",
answer: "Yes, business professionals and companies frequently use our online taxi booking facility for corporate transportation."
},
{
question: "Are Tempo Travellers available for group bookings?",
answer: "Yes, Tempo Travellers and larger vehicles are available for family trips, weddings, corporate outings, and group travel."
},
{
question: "Can I schedule a taxi in advance?",
answer: "Yes, advance booking is recommended to ensure vehicle availability and smooth travel planning."
},
{
question: "Are drivers experienced and verified?",
answer: "Yes, all drivers are professionally trained, experienced, and familiar with Mumbai roads and travel routes."
},
{
question: "Why choose Mumbai Airport Cabs for online taxi booking?",
answer: "Mumbai Airport Cabs offers reliable service, professional drivers, multiple vehicle choices, airport transfers, local rides, and outstation travel solutions."
}
];

const testimonials = [
{
id: 1,
name: "Mr. Nikhil Doshi",
feedback:
"Booking a taxi online was extremely simple and convenient. The confirmation was quick, the cab arrived on time, and the entire experience was seamless.",
rating: 5
},
{
id: 2,
name: "Mrs. Pooja Sharma",
feedback:
"Mumbai Airport Cabs made online booking effortless. The vehicle was clean, the driver was courteous, and the service exceeded our expectations.",
rating: 5
}
];












































   const Images = [
    { place: "/images/keyword/114.jpg", text: "Mumbai Outstation Cabs", link: "Mumbai-Outstation-Cabs" },
    { place: "/images/keyword/113.jpg", text: "Mumbai to Mahabaleshwar Cab", link: "Mumbai-to-Mahabaleshwar-Cab" },
    { place: "/images/keyword/112.jpg", text: "Mumbai to Goa Cabs", link: "Mumbai-to-Goa-Cabs" },
    { place: "/images/keyword/111.jpg", text: "Mumbai to Shirdi Cab", link: "Mumbai-to-Shirdi-Cab" },
    { place: "/images/keyword/110.jpg", text: "Mumbai Nashik Cab", link: "Mumbai-Nashik-Cab" },
    { place: "/images/keyword/109.jpg", text: "Mumbai to Kolhapur Cab", link: "Mumbai-to-Kolhapur-Cab" },
    { place: "/images/keyword/108.jpg", text: "Mumbai to Pune Cab", link: "Mumbai-to-Pune-Cab" },
    { place: "/images/keyword/107.jpg", text: "Mumbai to Aurangabad Cab", link: "Mumbai-to-Aurangabad-Cab" },
    { place: "/images/keyword/106.jpg", text: "Mumbai to Bhimashankar Cab", link: "Mumbai-to-Bhimashankar-Cab" },
    { place: "/images/keyword/105.jpg", text: "Mumbai to Ashtavinayak Cab Service", link: "Mumbai-to-Ashtavinayak-Cab-Service" },
    { place: "/images/keyword/104.jpg", text: "Mumbai to 5 Jyotirlinga Cab", link: "Mumbai-to-5-Jyotirlinga-Cab" },
    { place: "/images/keyword/103.jpg", text: "Mumbai to Lonavala Cab", link: "Mumbai-to-Lonavala-Cab" },
    { place: "/images/keyword/102.jpg", text: "Mumbai to Konkan Darshan Cab Booking", link: "Mumbai-to-Konkan-Darshan-Cab-Booking" },
    { place: "/images/keyword/101.jpg", text: "Mumbai to Alibaug Cab", link: "Mumbai-to-Alibaug-Cab" },
    { place: "/images/keyword/100.jpg", text: "Mumbai to Ahmednagar Cab", link: "Mumbai-to-Ahmednagar-Cab" },
    { place: "/images/keyword/99.jpg", text: "Mumbai to Matheran Cab", link: "Mumbai-to-Matheran-Cab" },
    { place: "/images/keyword/98.jpg", text: "Mumbai to Jalgaon Cab Booking / Dhule", link: "Mumbai-to-Jalgaon-Dhule-Cab-Booking" },
    { place: "/images/keyword/97.jpg", text: "Mumbai to Lavasa Cab", link: "Mumbai-to-Lavasa-Cab" },
    { place: "/images/keyword/96.jpg", text: "Mumbai to Panchgani Cab", link: "Mumbai-to-Panchgani-Cab" },
    { place: "/images/keyword/95.jpg", text: "Mumbai to Khandala Taxi Fare", link: "Mumbai-to-Khandala-Taxi-Fare" },
    { place: "/images/keyword/94.jpg", text: "Mumbai to Surat Cab", link: "Mumbai-to-Surat-Cab" },
    { place: "/images/keyword/93.jpg", text: "Mumbai to Ahmedabad Cab", link: "Mumbai-to-Ahmedabad-Cab" },
    { place: "/images/keyword/92.jpg", text: "Mumbai to Narmada Parikrama Cab Booking", link: "Mumbai-to-Narmada-Parikrama-Cab-Booking" },
    { place: "/images/keyword/91.jpg", text: "Mumbai to Baroda Cabs", link: "Mumbai-to-Baroda-Cabs" },
    { place: "/images/keyword/90.jpg", text: "Mumbai to Daman Taxi", link: "Mumbai-to-Daman-Taxi" },
];











const productSchema = {
"@context": "https://schema.org",
"@type": "Product",
"name": "Online Taxi Booking in Mumbai",
"image": "https://www.mumbaiairportcabs.com/assets/images/online-taxi-booking-mumbai.jpg",
"description": "Book online taxi in Mumbai instantly for local rides, airport transfers, outstation travel, and corporate trips. Mumbai Airport Cabs offers 24x7 fast and reliable online cab booking with professional drivers, clean vehicles, and affordable pricing.",
"brand": {
"@type": "Brand",
"name": "Mumbai Airport Cabs"
},
"aggregateRating": {
"@type": "AggregateRating",
"bestRating": "5",
"worstRating": "1",
"ratingValue": "4.8",
"ratingCount": "5471"
},
"offers": {
"@type": "Offer",
"priceCurrency": "INR",
"price": "Starting From ₹14/Km",
"availability": "https://schema.org/InStock",
"url": "https://www.mumbaiairportcabs.com/online-taxi-booking-mumbai"
}
};






    return (
        <div>



<Helmet>
  <title>Online Taxi Booking Mumbai | Instant Cab Service | +91 9545731161</title>

<meta
 name="description"
 content="Book online taxi in Mumbai instantly with 24x7 availability. Fast, easy, and reliable cab booking for local travel, airport transfers, and outstation trips at affordable fares."
/>

<meta
 name="keywords"
 content="online taxi booking mumbai, mumbai online cab booking, book taxi online mumbai, mumbai taxi booking app, instant taxi booking mumbai, fast taxi booking mumbai, easy online cab mumbai, mumbai ride booking online, 24x7 online taxi mumbai, app based taxi booking mumbai, mumbai cab booking online, quick taxi booking mumbai, digital taxi booking mumbai"
/>

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>

</Helmet>







            <div
                className="breadcumb-wrapper"
                style={{
                    backgroundImage: "url('/images/breadcumb/breadcumb-bg.jpg')",
                    backgroundSize: "cover",
                    backgroundPosition: "center",
                }}
            >
                <div className="container z-index-common">
                    <div className="breadcumb-content">
                        <h1 className="breadcumb-title">{cardData.keyword}</h1>
                    </div>
                </div>
            </div>


















            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/84.jpg' alt='img' className='img-fluid' />
                            <h3 className="py-1"
                                style={{
                                    color: '#1A4160', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >Mumbai Airport Cab: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="topPlaces">

                                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard borderr" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>

                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>


                            <div className="services-section">
                                {cardData.services.map((service, index) => (
                                    <div key={index} className="service-row">
                                        {/* <div className="service-icon">
                      🚗
                    </div> */}
                                        <div>
                                            <h4 className="service-title">{service.name}</h4>
                                            <p className="service-desc">{service.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>


                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section" className="why-choose-section">


                                {/* Section Title */}
                                <h2 className="section-title text-white">
                                    Why Choose <span>Mumbai Airport Cabs</span>
                                </h2>


                                {/* Cards */}
                                <div className="cards-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div key={index} className="why-card">
                                            <div className="icon-circle">{index + 1}</div>
                                            <h4 className="card-heading">{item.WhyChooseheading}</h4>
                                            <p className="card-desc">{item.WhyChoosedescription}</p>
                                        </div>
                                    ))}
                                </div>
                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Mumbai Airport Cabs </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title=""
                                                    subtitle=""
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase keyword={cardData.keyword} />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-telephone-fill"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+919545731161" className="pc-call">+91 9545731161</a>
                                        </div>

                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/919545731161"
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp"></i> WhatsApp
                                            </a>
                                            <a href="tel:+919545731161" className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-envelope-fill"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@mumbaiairportcabs.com" className="pc-email">
                                            booking@mumbaiairportcabs.com
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-geo-alt-fill"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Mumbai Airport Cabs</strong><br />

                                            SAWANT SADAN 05 Ramachandra cold drinks House,
                                            Near SBI Bank Nehru Road Opp Noble Medical,
                                            Vile Parle East Mumbai, 400057
                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Onlinetaxibookingmumbai;